import React, { Component } from "react";
import { PopAdmin } from "@/components/";
import MainLayout from "../main-layout/main-layout";

class FollowupAdminForm extends Component {
  public render() {
    return (
      <MainLayout>
        <PopAdmin></PopAdmin>
      </MainLayout>
    );
  }
}

export default FollowupAdminForm;
